import { render, staticRenderFns } from "./ReleasePuppy.vue?vue&type=template&id=624e5ff8"
import script from "./ReleasePuppy.vue?vue&type=script&lang=ts"
export * from "./ReleasePuppy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports